if (!customElements.get('collection-load-more')) {
  class CollectionLoadMore extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.js-btn-load-more');
      this.productGrid = document.querySelector('#product-grid');
      this.loading = false;
      // When enabled, the next page auto-loads as the loader scrolls into view
      // (infinite scroll). The custom element re-upgrades whenever the grid is
      // re-rendered (e.g. after a filter), so the observer is always in sync.
      this.infinite = this.dataset.infinite === 'true';

      if (this.button) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadMore();
        });

        if (this.infinite) {
          // A single persistent observer. After a load the loader is pushed down
          // by the appended products; it only fires again once it re-enters the
          // viewport, so pages load one-per-scroll instead of all at once.
          this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) this.loadMore();
            });
          });
          this.observer.observe(this.button);
        }
      }
    }

    async loadMore() {
      if (!this.button || !this.productGrid || this.loading) return;

      const url = this.button.dataset.href;
      if (!url) return;

      this.loading = true;
      this.button.setAttribute('disabled', 'true');
      this.button.classList.add('loading');

      try {
        const response = await fetch(url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const container = doc.querySelector('#ProductGridContainer');
        const nextGrid = container && container.querySelector('#product-grid');
        const nextLoadMore = container && container.querySelector('collection-load-more');

        if (nextGrid) {
          // Append the freshly fetched products to the current grid.
          this.productGrid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
        }

        // Reflect the loaded page in the address bar so the URL carries ?page=N
        // (shareable, bookmarkable, and crawlable on reload).
        history.replaceState({}, '', url);

        const isLastPage = !nextLoadMore || nextLoadMore.classList.contains('hidden');

        if (isLastPage) {
          this.classList.add('hidden');
          if (this.observer) this.observer.disconnect();
        } else {
          // Advance the loader to point at the next page.
          const nextButton = nextLoadMore.querySelector('.js-btn-load-more');
          if (nextButton) this.button.dataset.href = nextButton.dataset.href;
        }
      } catch (error) {
        console.error('[collection-load-more]', error);
      } finally {
        this.loading = false;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
      }
    }
  }

  customElements.define('collection-load-more', CollectionLoadMore);
}
